<template>
	<div
		class="point"
		ref="point"
		:class="transition ? 'transition_all' : 'transition_none'"
		:style="style"
		@touchstart="dragStart"
		@touchend.stop="dragEnd"
		@touchmove.prevent.stop="dragMove"
		@click.stop="click"
	>
		<consult v-if="!slotState"></consult>
		<slot v-else></slot>
	</div>
	<!-- @touchend事件的 .prevent 修饰符会导致click不能触发-->
</template>

<script>
const data = {
	border_distance: 20,
	divWidth: 0,
	divHeight: 0,
	moveLeft: 20,
	moveTop: 20,
	clientWidth: 0,
	clientHeight: 0,
	style: 'left: 20px;top: 20px',
	transition: false,
	top: 0
};
export default {
	name: 'FloatBtn',
	props: {
		position: {
			/* 
				auto：自动贴边
				left：只贴左边
				right：只贴右边
				none：自由模式，不贴边
			*/
			typeof: String,
			default: 'auto'
		},
		safeMargin: {
			//安全距离
			typeof: Number,
			default: 20
		},
		iosNavHeight: {
			//ios底部导航距离
			typeof: Number,
			default: 80
		},
		nav: {
			//默认导航是否开启，true开启状态，false关闭状态
			typeof: Boolean,
			default: false
		},
		slotState: {
			typeof: Boolean,
			default: false
		}
	},
	watch: {
		safeMargin(newVal) {
			this.border_distance = newVal;
		}
	},
	data() {
		return {
			border_distance: 20, //可拖拽元素距离屏幕边界最小距离
			divWidth: 0, //可拖拽元素宽度
			divHeight: 0, //可拖拽元素高度
			moveLeft: 20, //可拖拽元素距离屏幕左边界
			moveTop: 20, //可拖拽元素距离屏幕上边界
			clientWidth: document.documentElement.clientWidth, //屏幕宽度
			clientHeight: document.documentElement.clientHeight, //屏幕高度
			style: 'left: 20px;top: 20px',
			transition: false,
			top: 0
		};
	},
	created() {
		this.border_distance = this.safeMargin;
	},
	mounted() {
		this.init();
		console.log(this.clientWidth, this.clientHeight);
	},
	methods: {
		async init() {
			var element = document.getElementsByClassName('point')[0];
			const { offsetWidth, offsetHeight } = element;
			this.divWidth = offsetWidth;
			this.divHeight = offsetHeight;

			this.$nextTick(() => {
				/* 变更初始渲染左右侧位置或者直接修改定义中变量 ↓↓ */
				this.moveTop = this.clientHeight - this.divHeight - this.border_distance - this.iosNavHeight;
				/* 变更初始渲染上下侧位置或者直接修改定义中变量 ↓↓ */
				this.moveLeft = this.clientWidth - this.divWidth - this.border_distance;
				this.getNavHeight().then((res) => {
					this.top = res[0];
					if (!this.nav) {
						this.moveTop = this.moveTop + this.top * 2;
						this.style = `left: ${this.moveLeft}px;top: ${this.moveTop}px`;
					} else {
						this.clientHeight = this.clientHeight - this.top * 2;
					}
				});
			});
		},
		dragStart(e) {
			this.transition = false;
		},
		dragEnd(e) {
			this.transition = true;
			switch (this.position) {
				case 'auto':
					if (this.moveLeft > this.clientWidth / 2) {
						//若移动位于屏幕的左边或右边，则自动贴合左边或右边（此根据业务具体需求表现而定）
						this.moveLeft = this.clientWidth - this.divWidth - this.border_distance;
					} else {
						this.moveLeft = this.border_distance;
					}
					break;
				case 'left':
					this.moveLeft = this.border_distance;
					break;
				case 'right':
					this.moveLeft = this.clientWidth - this.divWidth - this.border_distance; //右侧自动贴边
					break;
				case 'none':
					break;
			}

			let navHeight = this.nav ? 0 : this.top;
			if (this.moveTop <= navHeight + this.divHeight) {
				this.moveTop = this.border_distance + navHeight;
			} else if (this.moveTop + this.divHeight >= this.clientHeight - navHeight - this.iosNavHeight) {
				this.moveTop = this.clientHeight - this.divHeight - this.border_distance - this.iosNavHeight;
			}

			this.style = `left: ${this.moveLeft}px;top: ${this.moveTop}px`;
		},
		dragMove(e) {
			// console.log(e);
			if (e.touches.length) {
				let touch = e.touches[0];
				this.moveLeft = touch.clientX - this.divWidth / 2; //因拖动的中间点为Dom节点的中心点，所以left需减去Dom节点一半的宽度
				this.moveTop = touch.clientY - this.divHeight / 2; //top原理同上
			}

			// console.log(this.moveLeft, this.moveTop);
			// let navHeight = this.nav ? 0 : this.top;
			// //判断x轴是否超出范围
			// if (this.moveLeft <= this.border_distance) {
			// 	//安全距离
			// 	this.moveLeft = this.border_distance;
			// } else if (this.moveLeft + this.divHeight >= this.clientWidth - this.border_distance) {
			// 	//元素完整位置是否超出屏幕宽度减安全距离
			// 	this.moveLeft = this.clientWidth - this.divWidth - this.border_distance;
			// }
			// //判断y轴是否超出范围
			// if (this.moveTop <= this.border_distance + navHeight) {
			// 	//安全距离加nav高度
			// 	this.moveTop = this.border_distance + navHeight;
			// } else if (this.moveTop + this.divHeight >= this.clientHeight - this.border_distance - this.iosNavHeight) {
			// 	//元素完整位置是否超出屏幕高度减安全距离
			// 	this.moveTop = this.clientHeight - this.divHeight - this.border_distance - this.iosNavHeight;
			// }

			this.style = `left: ${this.moveLeft}px;top: ${this.moveTop}px`;
		},
		getNavHeight() {
			//获取导航栏高度，可自定义
			return new Promise((resolve) => {
				let list = [0, 0, 0];
				resolve(list);
			});
		},
		refLoad() {
			//重置
			for (let key in data) {
				this[key] = data[key];
			}
		},
		click() {
			this.$emit('click');
		}
	}
};
</script>

<style lang="less" scoped>
.point {
	position: fixed;
	z-index: 1000;
}

.transition_none {
	transition: none;
}

.transition_all {
	transition: all 0.3s;
}
</style>
